import React, { SyntheticEvent, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import MuiLink from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { Typography } from '@material-ui/core';
import { Auth } from 'aws-amplify';
import UnathorizedLayout from '../../shared/layout/UnauthorizedLayout';
import { useStyles } from './styles';
import { AlertContext } from '../../shared/app/AlertProvider';
import { IError } from '../../../types';

const Success = () => {
  const { t } = useTranslation();

  const classes = useStyles();

  const { state: locationState } = useLocation<locationState>();

  const { showAlert } = useContext(AlertContext);

  const resendEmail = async (e: SyntheticEvent) => {
    e.preventDefault();
    if (locationState.email != null) {
      Auth.forgotPassword(locationState.email)
        .then(() => {
          showAlert({
            severity: 'success',
            message: t(
              'v2.verification.snackbar_label_resetPasswordEmailSentOut',
            ),
          });
        })
        .catch((err: IError) => {
          showAlert({
            severity: 'error',
            message: t('v2.global.snackbar_label_error_somethingWentWrong'),
          });
        });
    }
  };

  return (
    <UnathorizedLayout
      title={t('v2.passwordEmailConfirmation.header_label_title')}
      subtitle={t('v2.passwordEmailConfirmation.header_label_subTitle')}
    >
      <Box className={classes.content}>
        {locationState && (
          <>
            <Typography
              component="label"
              variant="body2"
              className={classes.label}
            >
              {t('v2.global.textField_label_companyEmail')}
            </Typography>
            <Typography
              component="div"
              variant="body1"
              className={classes.labelValue}
            >
              {locationState.email}
            </Typography>
            <Box pt={3} />
            <Grid item xs={12}>
              {t('v2.verification.label_resendEmail')}
              <MuiLink
                component="a"
                variant="body1"
                className={classes.links}
                href="#"
                onClick={resendEmail}
              >
                {t('v2.verification.button_resendEmail')}
              </MuiLink>
            </Grid>
          </>
        )}

        <Grid item xs={12}>
          {t('v2.global.label_needHelp')}
          <MuiLink
            component="a"
            variant="body1"
            className={classes.links}
            href={`mailto:${process.env.REACT_APP_CONTACT_EMAIL}`}
          >
            {t('v2.global.button_needHelp')}
          </MuiLink>
        </Grid>
      </Box>
    </UnathorizedLayout>
  );
};

export default Success;

type locationState = {
  email?: string;
};
